import * as React from "react";

const Mastercard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    fill="none"
    viewBox="0 -9 58 58"
  >
    <rect
      width="57"
      height="39"
      x="0.5"
      y="0.5"
      fill="#fff"
      stroke="#F3F3F3"
      rx="3.5"
    ></rect>
    <path fill="#FF5F00" d="M34.31 28.977H23.96V10.512h10.35z"></path>
    <path
      fill="#EB001B"
      d="M24.622 19.743c0-3.746 1.767-7.082 4.519-9.232A11.84 11.84 0 0 0 21.829 8C15.296 8 10 13.257 10 19.743c0 6.485 5.296 11.743 11.83 11.743 2.76 0 5.299-.939 7.31-2.511-2.75-2.15-4.518-5.487-4.518-9.232"
    ></path>
    <path
      fill="#F79E1B"
      d="M48.27 19.743c0 6.485-5.296 11.743-11.829 11.743-2.76 0-5.299-.939-7.312-2.511 2.752-2.15 4.52-5.487 4.52-9.232 0-3.746-1.768-7.082-4.52-9.232A11.84 11.84 0 0 1 36.441 8c6.533 0 11.83 5.257 11.83 11.743"
    ></path>
  </svg>
);

export default Mastercard;
